var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no-emission-alert-form-component"}},[_c('v-text-field',{attrs:{"label":_vm.$t('dialog_update_alert_component.number_hours_without_emissions'),"filled":"","type":"number"},model:{value:(_vm.configuration.limit),callback:function ($$v) {_vm.$set(_vm.configuration, "limit", $$v)},expression:"configuration.limit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }